import { request } from '@/apis/request';
import httpApi from '@/apis/httpApi';

// 敏感词屏蔽
export function apiGetBlackWords() {
  return request<string[]>({
    method: 'GET',
    url: httpApi.home.getBlackWords
  });
}
